import request from '@/utils/request'

// getRequestHead
export function getRequestHead(param) {
  let data = param
  return request({
    url: `/po/epms4050/getRequestHead`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
